import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom'
import Layout from './components/Layout'
import IndexPage from './pages/IndexPage'
import DocViewer from './pages/docs/DocViewer'
import WikiIndex from './pages/docs/WikiIndex'
import WikiViewer from './pages/docs/WikiViewer'
import ContentViewer from './pages/docs/ContentViewer'
import ApiDocPage from './pages/apis/ApiDocPage'
import SoftwareIndex from './pages/software/SoftwareIndex'
import PlayerSoftware from './pages/software/PlayerSoftware'
import PlayerHome from './pages/software/player/PlayerHome'
import PlayerRequirements from './pages/software/player/PlayerRequirements'
import PlayerPlatformsIndex from './pages/software/player/PlayerPlatformsIndex'
import PlayerWindows from './pages/software/player/PlayerWindows'
import PlayerLinux from './pages/software/player/PlayerLinux'
import PlayerSamsungTizen from './pages/software/player/PlayerSamsungTizen'
import PlayerLgWebos from './pages/software/player/PlayerLgWebos'
import ContentCacheProxy from './pages/software/ContentCacheProxy'
import IntegrationServer from './pages/software/IntegrationServer'
import SoftwareStub from './pages/software/SoftwareStub'
import DocumentationIndex from './pages/development/DocumentationIndex'
import AppIntegrationDev from './pages/development/AppIntegrationDev'
import SupportIndex from './pages/support/SupportIndex'

function App() {
  return (
    <BrowserRouter
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true,
      }}
    >
      <Routes>
        <Route path="/" element={<Layout/>}>
          {/* Index page */}
          <Route index element={<IndexPage/>}/>

          {/* Software section */}
          <Route path="software">
            <Route index element={<SoftwareIndex/>}/>
            <Route path="player-software" element={<PlayerSoftware/>}>
              <Route index element={<PlayerHome/>}/>
              <Route path="requirements" element={<PlayerRequirements/>}/>
              <Route path="supported-platforms">
                <Route index element={<PlayerPlatformsIndex/>}/>
                <Route path="windows" element={<PlayerWindows/>}/>
                <Route path="linux" element={<PlayerLinux/>}/>
                <Route path="samsung-tizen" element={<PlayerSamsungTizen/>}/>
                <Route path="lg-webos" element={<PlayerLgWebos/>}/>
              </Route>
            </Route>
            <Route path="content-cache-proxy" element={<ContentCacheProxy/>}>
              <Route index element={<SoftwareStub title="Overview & Architecture"/>}/>
              <Route path="installation" element={<SoftwareStub title="Installation & Configuration"/>}/>
              <Route path="monitoring" element={<SoftwareStub title="Monitoring & Troubleshooting"/>}/>
            </Route>
            <Route path="integration-server" element={<IntegrationServer/>}>
              <Route index element={<SoftwareStub title="Overview & Capabilities"/>}/>
              <Route path="installation" element={<SoftwareStub title="Installation & Configuration"/>}/>
              <Route path="webhooks" element={<SoftwareStub title="Webhooks & Authentication"/>}/>
            </Route>
          </Route>

          {/* Docs section */}
          <Route path="docs">
            <Route index element={<DocumentationIndex/>}/>

            {/* Getting started now lives at /docs (index) */}
            <Route path="getting-started" element={<Navigate to="/docs" replace/>}/>

            {/* Universal content viewer mounted under /docs/:source/* */}
            <Route path=":source/*" element={<ContentViewer/>}/>

            {/* Wiki space */}
            <Route path="wiki">
              <Route index element={<WikiIndex/>}/>
              <Route path="*" element={<WikiViewer/>}/>
            </Route>

            {/* API docs under Docs */}
            <Route path="api-docs">
              {/* Drop the standalone index; redirect to Docs overview */}
              <Route index element={<Navigate to="/docs" replace/>}/>
              <Route path=":apiId" element={<ApiDocPage/>}/>
              <Route path=":apiId/:version" element={<ApiDocPage/>}/>
            </Route>

            {/* App Integration & Development */}
            <Route path="app-integration-development/*" element={<AppIntegrationDev/>}/>
            {/* Fallback to markdown/doc viewer */}
            <Route path="*" element={<DocViewer/>}/>
          </Route>

          {/* Support section */}
          <Route path="support" element={<SupportIndex/>}/>

          {/* Catch-all */}
          <Route path="*" element={<Navigate to="/" replace/>}/>
        </Route>
      </Routes>
    </BrowserRouter>
  )
}

export default App
